// // src/pages/treatments/OrganTransplantPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const ORGAN_TRANSPLANT_TREATMENT = {
//   slug: "organ-transplant",
//   name: "Organ Transplant",
//   shortName: "Organ Transplant",
//   tagline: "A New Organ. A New Beginning. Expert Hands. Proven Survival.",
//   heroSubtag:
//     "World-class organ transplant surgery at a fraction of Western costs. India's top transplant surgeons. Life-saving outcomes.",
//   description:
//     "Comprehensive organ transplant care covering kidney, liver, heart, lung, pancreas and bone marrow transplants — supported by advanced immunology, dedicated transplant ICUs, and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every international case within 48 hours to deliver globally benchmarked, personalised treatment plans with exceptional survival rates.",
//   heroImage: "/OrganTransplant.jpeg",
//   category: "Organ Transplant",
//   badge: "Life-Saving Surgery",
//   accentColor: "red",
//   costCard: {
//     label: "Organ transplant packages from",
//     value: "₹8L–₹35L",
//     compare: "vs. $150,000–$500,000 in the USA",
//     stay: "Typically 4–8 weeks in India post-surgery depending on organ",
//     stayCompare: "vs. £100,000–£300,000 in the UK",
//   },
//   stats: [
//     { label: "1-Year Survival Rate", value: "90%+", icon: Award },
//     { label: "Transplants Performed", value: "15,000+", icon: Users },
//     { label: "Years Experience", value: "30+", icon: Shield },
//     { label: "Organs Transplanted", value: "6 Types", icon: Clock },
//   ],
//   benefits: [
//     "Kidney, liver, heart, lung, pancreas and bone marrow transplant programmes",
//     "Living donor and deceased donor transplant pathways",
//     "Dedicated multi-organ transplant ICUs with 24/7 specialist cover",
//     "Advanced HLA tissue typing and cross-matching laboratory",
//     "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
//     "Immunosuppression management and lifelong rejection monitoring",
//     "Urgent listing and fast-track evaluation for acute organ failure",
//     "Paediatric transplant programme for children from infancy onwards",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Evaluation & Work-Up",
//       desc: "Complete organ-specific assessment — imaging, cardiac clearance, HLA typing, donor compatibility testing and transplant committee approval.",
//       duration: "1–2 Weeks",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Donor Assessment",
//       desc: "Living donor undergoes independent full medical, surgical, psychological and ethical evaluation to confirm safe organ donation.",
//       duration: "1–2 Weeks",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Transplant Surgery",
//       desc: "Simultaneous donor and recipient surgery by senior transplant surgeons in adjacent theatres under general anaesthesia.",
//       duration: "4–16 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Long-Term Follow-Up",
//       desc: "Transplant ICU monitoring, immunosuppression initiation, rejection surveillance and discharge with lifelong outpatient follow-up protocol.",
//       duration: "4–8 Weeks",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Which organ transplants are available in India?",
//       a: "India offers kidney, liver, heart, lung, pancreas, small bowel and bone marrow (haematopoietic stem cell) transplants. Kidney and liver transplants are the most commonly performed, with India ranking among the top three countries globally for living donor liver transplant volume and outcomes.",
//     },
//     {
//       q: "Can I bring my own living donor from my home country?",
//       a: "Yes. Many international patients travel with a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full independent evaluation at the Indian hospital before surgery is confirmed. Blood group compatibility and relationship proof are required.",
//     },
//     {
//       q: "What are the survival rates for organ transplants in India?",
//       a: "Leading Indian transplant centres report: Kidney — 95%+ at 1 year; Liver — 90–95% at 1 year; Heart — 85–90% at 1 year; Bone Marrow — 70–85% depending on disease and donor type. These outcomes are comparable to the best transplant centres in the USA and Europe.",
//     },
//     {
//       q: "How long will I need to stay in India after transplant?",
//       a: "Stay duration varies by organ: Kidney recipients typically stay 3–4 weeks; Liver recipients 6–8 weeks; Heart and lung recipients 8–12 weeks. PaxGrow arranges serviced accommodation near the hospital for accompanying family members throughout the recovery period.",
//     },
//     {
//       q: "What immunosuppression will I need after transplant?",
//       a: "All transplant recipients require lifelong immunosuppression to prevent rejection. Common medications include tacrolimus, mycophenolate and prednisolone. Your Indian transplant team provides a detailed protocol and coordinates with your home physician for ongoing prescriptions. Monthly blood monitoring is required for life.",
//     },
//     {
//       q: "How much does organ transplant cost in India vs. the UK or USA?",
//       a: "Organ transplant packages in India are 80–90% less expensive than equivalent procedures in the USA or UK. A kidney transplant costs ₹8L–₹12L ($10,000–$15,000) vs $150,000–$300,000 in the USA. A liver transplant costs ₹20L–₹35L vs $300,000–$500,000 in the USA — with equivalent or superior survival outcomes at top Indian centres.",
//     },
//     {
//       q: "Is bone marrow transplant available for international patients?",
//       a: "Yes. Both autologous (own stem cells) and allogeneic (matched donor) bone marrow transplants are available. India has one of the most active unrelated donor registries in Asia, and international patients can also bring a matched sibling donor. Indications include leukaemia, lymphoma, myeloma, aplastic anaemia and thalassaemia.",
//     },
//     {
//       q: "What happens if my body rejects the transplanted organ?",
//       a: "Rejection episodes — particularly acute rejection in the first 3–6 months — are manageable with high-dose immunosuppression in most cases. Your transplant team provides a 24/7 emergency contact protocol. PaxGrow maintains 90-day follow-up contact after your return and connects you immediately with your Indian transplant team if any concern arises.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. A. S. Soin",
//       specialty: "Liver Transplant & HPB Surgery",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3800,
//       image: "https://randomuser.me/api/portraits/men/52.jpg",
//       qualifications: "MBBS, MS, MCh (HPB), FRCS (Edinburgh)",
//       hospital: "Medanta — The Medicity, Gurgaon",
//     },
//     {
//       name: "Dr. Sandeep Guleria",
//       specialty: "Kidney Transplant & Urology",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 3200,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "MBBS, MS, MCh (Urology), FRCS",
//       hospital: "Indraprastha Apollo Hospital, Delhi",
//     },
//     {
//       name: "Dr. Balram Bhargava",
//       specialty: "Heart Transplant & Cardiology",
//       experience: "32 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       qualifications: "MBBS, MD (Cardiology), DM, FAMS",
//       hospital: "AIIMS, New Delhi",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Samuel Otieno",
//       age: 46,
//       location: "Kampala, Uganda",
//       text: "Both my kidneys had failed and I was on dialysis three times a week. My wife donated one of her kidneys in Delhi. Within three weeks of surgery my creatinine was normal and I was off dialysis completely. PaxGrow handled everything — visa, airport pickup, accommodation. I cannot put into words what this team did for my family.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/44.jpg",
//       treatment: "Living Donor Kidney Transplant — End-Stage Renal Disease",
//       date: "October 2023",
//     },
//     {
//       name: "Fatima Abdullahi",
//       age: 34,
//       location: "Dar es Salaam, Tanzania",
//       text: "My younger brother had acute liver failure from hepatitis B. We were told he had days to live. PaxGrow arranged an emergency review within hours and we were on a flight to Chennai the next morning. The transplant team performed a living donor transplant using a portion of my liver. He is now completely healthy and back at university.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/58.jpg",
//       treatment: "Emergency Living Donor Liver Transplant — Acute Liver Failure",
//       date: "January 2024",
//     },
//     {
//       name: "Ahmed Al-Zahrani",
//       age: 29,
//       location: "Riyadh, Saudi Arabia",
//       text: "I was diagnosed with aplastic anaemia and told I needed a bone marrow transplant urgently. My sister was a perfect match. The haematology team at Fortis performed the allogeneic transplant and I achieved full engraftment by day 28. I am now 14 months post-transplant and in complete remission.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/37.jpg",
//       treatment: "Allogeneic Bone Marrow Transplant — Aplastic Anaemia",
//       date: "February 2024",
//     },
//   ],
// };

// const ORGAN_TRANSPLANT_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Organ Transplant",
//   whyIndiaReasons: [
//     "India performs more living donor organ transplants than any country outside the USA — with 90–95% one-year survival at top centres for kidney and liver",
//     "Multidisciplinary transplant boards review international cases within 48 hours of receiving medical reports — urgent cases prioritised same day",
//     "Living donor surgery confirmed within 3–6 weeks — no deceased donor waiting lists of years as in the UK, USA or Canada",
//     "AIIMS, Medanta, Apollo, Fortis, Max, CMC Vellore — globally ranked transplant programmes with full published outcome transparency",
//   ],
//   conditionsTitle: "Organ Transplant Conditions We Facilitate",
//   conditions: [
//     "End-Stage Renal Disease (Kidney Transplant)",
//     "Liver Cirrhosis & Acute Liver Failure",
//     "Hepatocellular Carcinoma (Liver Transplant)",
//     "End-Stage Heart Failure (Heart Transplant)",
//     "Chronic Obstructive Pulmonary Disease (Lung Transplant)",
//     "Type 1 Diabetes — Pancreas Transplant",
//     "Leukaemia & Lymphoma (Bone Marrow Transplant)",
//     "Aplastic Anaemia (Bone Marrow Transplant)",
//     "Thalassaemia Major (Bone Marrow Transplant)",
//     "Biliary Atresia — Paediatric Liver Transplant",
//     "Polycystic Kidney Disease",
//     "Autoimmune Hepatitis & PSC",
//   ],
//   stayValue:
//     "Kidney: 3–4 weeks · Liver: 6–8 weeks · Heart/Lung: 8–12 weeks · Bone Marrow: 8–10 weeks. PaxGrow arranges serviced accommodation near the hospital for the full recovery period.",
//   costTitle: "Why India for Organ Transplant?",
//   costRows: [
//     {
//       procedure: "Living Donor Kidney Transplant",
//       india: "₹8L–₹12L",
//       africa: "Largely unavailable",
//       ukusa: "$150,000–$300,000",
//     },
//     {
//       procedure: "Living Donor Liver Transplant",
//       india: "₹20L–₹30L",
//       africa: "Largely unavailable",
//       ukusa: "$300,000–$500,000",
//     },
//     {
//       procedure: "Heart Transplant",
//       india: "₹25L–₹40L",
//       africa: "Largely unavailable",
//       ukusa: "$1,000,000+",
//     },
//     {
//       procedure: "Bone Marrow Transplant (Allogeneic)",
//       india: "₹15L–₹25L",
//       africa: "Largely unavailable",
//       ukusa: "$200,000–$400,000",
//     },
//     {
//       procedure: "Lung Transplant",
//       india: "₹30L–₹45L",
//       africa: "Largely unavailable",
//       ukusa: "$800,000–$1,200,000",
//     },
//   ],
// };

// const OrganTransplantPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={ORGAN_TRANSPLANT_TREATMENT}
//       paxgrowData={ORGAN_TRANSPLANT_PAXGROW}
//     />
//   );
// };

// export default OrganTransplantPage;


// src/pages/treatments/OrganTransplantPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const ORGAN_TRANSPLANT_TREATMENT = {
  slug: "organ-transplant",
  name: "Organ Transplant",
  shortName: "Organ Transplant",
  tagline: "A New Organ. A New Beginning. Expert Hands. Proven Survival.",
  heroSubtag:
    "World-class organ transplant surgery at a fraction of Western costs. India's top transplant surgeons. Life-saving outcomes.",
  description:
    "Comprehensive organ transplant care covering kidney, liver, heart, lung, pancreas and bone marrow transplants — supported by advanced immunology, dedicated transplant ICUs, and lifelong post-transplant follow-up. Our multidisciplinary transplant boards review every international case within 48 hours to deliver globally benchmarked, personalised treatment plans with exceptional survival rates.",
  heroImage: "/OrganTransplant.jpeg",
  category: "Organ Transplant",
  badge: "Life-Saving Surgery",
  accentColor: "red",
  costCard: {
    label: "Organ transplant packages from",
    value: "$9,500–$42,000",
    compare: "vs. $150,000–$500,000 in the USA",
    stay: "Typically 4–8 weeks in India post-surgery depending on organ",
    stayCompare: "vs. $120,000–$360,000 in the UK",
  },
  stats: [
    { label: "1-Year Survival Rate", value: "90%+", icon: Award },
    { label: "Transplants Performed", value: "15,000+", icon: Users },
    { label: "Years Experience", value: "30+", icon: Shield },
    { label: "Organs Transplanted", value: "6 Types", icon: Clock },
  ],
  benefits: [
    "Kidney, liver, heart, lung, pancreas and bone marrow transplant programmes",
    "Living donor and deceased donor transplant pathways",
    "Dedicated multi-organ transplant ICUs with 24/7 specialist cover",
    "Advanced HLA tissue typing and cross-matching laboratory",
    "Comprehensive donor workup — medical, surgical, psychological and ethical evaluation",
    "Immunosuppression management and lifelong rejection monitoring",
    "Urgent listing and fast-track evaluation for acute organ failure",
    "Paediatric transplant programme for children from infancy onwards",
  ],
  procedure: [
    {
      step: "01",
      title: "Evaluation & Work-Up",
      desc: "Complete organ-specific assessment — imaging, cardiac clearance, HLA typing, donor compatibility testing and transplant committee approval.",
      duration: "1–2 Weeks",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Donor Assessment",
      desc: "Living donor undergoes independent full medical, surgical, psychological and ethical evaluation to confirm safe organ donation.",
      duration: "1–2 Weeks",
      icon: Activity,
    },
    {
      step: "03",
      title: "Transplant Surgery",
      desc: "Simultaneous donor and recipient surgery by senior transplant surgeons in adjacent theatres under general anaesthesia.",
      duration: "4–16 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Long-Term Follow-Up",
      desc: "Transplant ICU monitoring, immunosuppression initiation, rejection surveillance and discharge with lifelong outpatient follow-up protocol.",
      duration: "4–8 Weeks",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Which organ transplants are available in India?",
      a: "India offers kidney, liver, heart, lung, pancreas, small bowel and bone marrow (haematopoietic stem cell) transplants. Kidney and liver transplants are the most commonly performed, with India ranking among the top three countries globally for living donor liver transplant volume and outcomes.",
    },
    {
      q: "Can I bring my own living donor from my home country?",
      a: "Yes. Many international patients travel with a family member as the living donor. PaxGrow arranges medical visas for both recipient and donor simultaneously. The donor undergoes full independent evaluation at the Indian hospital before surgery is confirmed. Blood group compatibility and relationship proof are required.",
    },
    {
      q: "What are the survival rates for organ transplants in India?",
      a: "Leading Indian transplant centres report: Kidney — 95%+ at 1 year; Liver — 90–95% at 1 year; Heart — 85–90% at 1 year; Bone Marrow — 70–85% depending on disease and donor type. These outcomes are comparable to the best transplant centres in the USA and Europe.",
    },
    {
      q: "How long will I need to stay in India after transplant?",
      a: "Stay duration varies by organ: Kidney recipients typically stay 3–4 weeks; Liver recipients 6–8 weeks; Heart and lung recipients 8–12 weeks. PaxGrow arranges serviced accommodation near the hospital for accompanying family members throughout the recovery period.",
    },
    {
      q: "What immunosuppression will I need after transplant?",
      a: "All transplant recipients require lifelong immunosuppression to prevent rejection. Common medications include tacrolimus, mycophenolate and prednisolone. Your Indian transplant team provides a detailed protocol and coordinates with your home physician for ongoing prescriptions. Monthly blood monitoring is required for life.",
    },
    {
      q: "How much does organ transplant cost in India vs. the UK or USA?",
      a: "Organ transplant packages in India are 80–90% less expensive than equivalent procedures in the USA or UK. A kidney transplant costs $10,000–$15,000 vs $150,000–$300,000 in the USA. A liver transplant costs $25,000–$42,000 vs $300,000–$500,000 in the USA — with equivalent or superior survival outcomes at top Indian centres.",
    },
    {
      q: "Is bone marrow transplant available for international patients?",
      a: "Yes. Both autologous (own stem cells) and allogeneic (matched donor) bone marrow transplants are available. India has one of the most active unrelated donor registries in Asia, and international patients can also bring a matched sibling donor. Indications include leukaemia, lymphoma, myeloma, aplastic anaemia and thalassaemia.",
    },
    {
      q: "What happens if my body rejects the transplanted organ?",
      a: "Rejection episodes — particularly acute rejection in the first 3–6 months — are manageable with high-dose immunosuppression in most cases. Your transplant team provides a 24/7 emergency contact protocol. PaxGrow maintains 90-day follow-up contact after your return and connects you immediately with your Indian transplant team if any concern arises.",
    },
  ],
  doctors: [
    {
      name: "Dr. A. S. Soin",
      specialty: "Liver Transplant & HPB Surgery",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3800,
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      qualifications: "MBBS, MS, MCh (HPB), FRCS (Edinburgh)",
      hospital: "Medanta — The Medicity, Gurgaon",
    },
    {
      name: "Dr. Sandeep Guleria",
      specialty: "Kidney Transplant & Urology",
      experience: "28 Years",
      rating: 4.9,
      reviews: 3200,
      image: "https://randomuser.me/api/portraits/men/63.jpg",
      qualifications: "MBBS, MS, MCh (Urology), FRCS",
      hospital: "Indraprastha Apollo Hospital, Delhi",
    },
    {
      name: "Dr. Balram Bhargava",
      specialty: "Heart Transplant & Cardiology",
      experience: "32 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      qualifications: "MBBS, MD (Cardiology), DM, FAMS",
      hospital: "AIIMS, New Delhi",
    },
  ],
  testimonials: [
    {
      name: "Samuel Otieno",
      age: 46,
      location: "Kampala, Uganda",
      text: "Both my kidneys had failed and I was on dialysis three times a week. My wife donated one of her kidneys in Delhi. Within three weeks of surgery my creatinine was normal and I was off dialysis completely. PaxGrow handled everything — visa, airport pickup, accommodation. I cannot put into words what this team did for my family.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      treatment: "Living Donor Kidney Transplant — End-Stage Renal Disease",
      date: "October 2023",
    },
    {
      name: "Fatima Abdullahi",
      age: 34,
      location: "Dar es Salaam, Tanzania",
      text: "My younger brother had acute liver failure from hepatitis B. We were told he had days to live. PaxGrow arranged an emergency review within hours and we were on a flight to Chennai the next morning. The transplant team performed a living donor transplant using a portion of my liver. He is now completely healthy and back at university.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/58.jpg",
      treatment: "Emergency Living Donor Liver Transplant — Acute Liver Failure",
      date: "January 2024",
    },
    {
      name: "Ahmed Al-Zahrani",
      age: 29,
      location: "Riyadh, Saudi Arabia",
      text: "I was diagnosed with aplastic anaemia and told I needed a bone marrow transplant urgently. My sister was a perfect match. The haematology team at Fortis performed the allogeneic transplant and I achieved full engraftment by day 28. I am now 14 months post-transplant and in complete remission.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/37.jpg",
      treatment: "Allogeneic Bone Marrow Transplant — Aplastic Anaemia",
      date: "February 2024",
    },
  ],
};

const ORGAN_TRANSPLANT_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Organ Transplant",
  whyIndiaReasons: [
    "India performs more living donor organ transplants than any country outside the USA — with 90–95% one-year survival at top centres for kidney and liver",
    "Multidisciplinary transplant boards review international cases within 48 hours of receiving medical reports — urgent cases prioritised same day",
    "Living donor surgery confirmed within 3–6 weeks — no deceased donor waiting lists of years as in the UK, USA or Canada",
    "AIIMS, Medanta, Apollo, Fortis, Max, CMC Vellore — globally ranked transplant programmes with full published outcome transparency",
  ],
  conditionsTitle: "Organ Transplant Conditions We Facilitate",
  conditions: [
    "End-Stage Renal Disease (Kidney Transplant)",
    "Liver Cirrhosis & Acute Liver Failure",
    "Hepatocellular Carcinoma (Liver Transplant)",
    "End-Stage Heart Failure (Heart Transplant)",
    "Chronic Obstructive Pulmonary Disease (Lung Transplant)",
    "Type 1 Diabetes — Pancreas Transplant",
    "Leukaemia & Lymphoma (Bone Marrow Transplant)",
    "Aplastic Anaemia (Bone Marrow Transplant)",
    "Thalassaemia Major (Bone Marrow Transplant)",
    "Biliary Atresia — Paediatric Liver Transplant",
    "Polycystic Kidney Disease",
    "Autoimmune Hepatitis & PSC",
  ],
  stayValue:
    "Kidney: 3–4 weeks · Liver: 6–8 weeks · Heart/Lung: 8–12 weeks · Bone Marrow: 8–10 weeks. PaxGrow arranges serviced accommodation near the hospital for the full recovery period.",
  costTitle: "Why India for Organ Transplant?",
  costRows: [
    {
      procedure: "Living Donor Kidney Transplant",
      india: "$9,500–$14,500",
      africa: "Largely unavailable",
      ukusa: "$150,000–$300,000",
    },
    {
      procedure: "Living Donor Liver Transplant",
      india: "$24,000–$36,000",
      africa: "Largely unavailable",
      ukusa: "$300,000–$500,000",
    },
    {
      procedure: "Heart Transplant",
      india: "$30,000–$48,000",
      africa: "Largely unavailable",
      ukusa: "$1,000,000+",
    },
    {
      procedure: "Bone Marrow Transplant (Allogeneic)",
      india: "$18,000–$30,000",
      africa: "Largely unavailable",
      ukusa: "$200,000–$400,000",
    },
    {
      procedure: "Lung Transplant",
      india: "$36,000–$54,000",
      africa: "Largely unavailable",
      ukusa: "$800,000–$1,200,000",
    },
  ],
};

const OrganTransplantPage = () => {
  return (
    <TreatmentTemplate
      treatment={ORGAN_TRANSPLANT_TREATMENT}
      paxgrowData={ORGAN_TRANSPLANT_PAXGROW}
    />
  );
};

export default OrganTransplantPage;